import { useEffect, useState } from 'react';

import useScriptLoader, { SCRIPTS } from '../../context/ScriptLoader/useScriptLoader';
import { LearnerInfo } from '../../types';
import { handleUserComPayload, getRoleForUserCom } from '../helpers';
import getUserComUserId from '../helpers/getUserComUserId';
import { useAuth } from '../hooks';

const useInitUserCom = (location, userInfo?: LearnerInfo | null) => {
  const prefix = '/rxd';

  const [isInitializedUserCom, setIsInitializedUserCom] = useState(false);

  const isUserComLoaded = useScriptLoader(SCRIPTS.USER_COM);
  const { isInitialized, isLoading, isAuthenticated } = useAuth();

  useEffect(() => {
    if (
      isUserComLoaded &&
      isInitialized &&
      !isLoading &&
      window?.UE?.pageHit &&
      location?.pathname?.slice(0, prefix.length) !== prefix &&
      !isInitializedUserCom
    ) {
      if (isAuthenticated) {
        if (userInfo) {
          const role = getRoleForUserCom(userInfo);
          setIsInitializedUserCom(true);
          window?.UE?.pageHit({
            apiKey: process.env.REACT_APP_USERCOM_API_KEY,
            user_id: getUserComUserId(userInfo.id),
            email: userInfo?.email,
            referrer_url: document?.referrer,
            ...(!userInfo?.has_subscription && { has_subscription: false }),
            had_subscription_bool: Boolean(userInfo?.had_subscription),
            owned_subscription: Boolean(userInfo?.owned_subscription),
            ...(userInfo?.name && { name: userInfo.name }),
            team_id:
              userInfo.teams?.length && userInfo?.teams?.[0]?.id ? userInfo?.teams?.[0]?.id : '',
            team_name:
              userInfo.teams?.length && userInfo?.teams?.[0]?.name
                ? userInfo?.teams?.[0]?.name
                : '',
            company_name: userInfo?.company?.name ? userInfo.company.name : '',
            ...(role && { role }),
            is_registered_user: true,
            onPayloadReceived: handleUserComPayload(userInfo),
          });
        }
      } else {
        setIsInitializedUserCom(true);
        window?.UE?.pageHit({
          apiKey: process.env.REACT_APP_USERCOM_API_KEY,
          referrer_url: document?.referrer,
          onPayloadReceived: handleUserComPayload(null),
        });
      }
    }
  }, [
    isAuthenticated,
    isInitialized,
    isLoading,
    userInfo,
    isUserComLoaded,
    location,
    isInitializedUserCom,
  ]);
};

export default useInitUserCom;
